import React, { Suspense, lazy } from 'react'
import { Route } from 'react-router'
import styles from './TMSApp.scss'
import { Translations } from './Translations'
import { Jobs } from './Jobs'
import { StandardLayout } from 'common/layouts/StandardLayout'
const Nav = lazy(() => import('./Nav'))
// const Translations = lazy(() => import('./Translations'))
// const Jobs = lazy(() => import('./Jobs'))

const Wrapper = ({ children, params, location }) => {
  const tab = location.pathname.includes('translations')
    ? 'translations'
    : 'jobs'
  return <StandardLayout greyBg style={{ flexFlow: 'column wrap' }} >
    <div className={styles.top}>
      <div className={styles.sidebar}>
        <Suspense fallback={<></>}>
          <Nav highlightedId={parseInt(params.id, 10)} pathTab={tab} />
        </Suspense>
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  </StandardLayout>
}

export const routes = <Route component={Wrapper}>
  <Route path='translations(/:id)' component={Translations} />
  <Route path='jobs(/:id)' component={Jobs} />
</Route>
